import { useEffect, useState, useRef } from "react";

import styles from "./Face3.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.028 * cardRef.current.clientWidth));
        setLetterSpacing(0.006 * cardRef.current.clientWidth);
        setLineHeight(0.07 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
        }}
      >
        <p>You say</p>
        <p>Strip her, bare her!</p>
        <p>and then when I glister</p>
        <p>into horoscopes you take off.</p>
        <p>Not possible,</p>
        <p>doesn&#39;t work like that</p>
        <p>One by one</p>
        <p>backwards, mean</p>
        <p>the worst</p>
        <p>truly grim.</p>
        <p>(also period tomorrow).</p>
      </div>
    </div>
  );
}
